module.exports = __webpack_public_path__ + "static/media/signage-industrial-img32.82cf7b02.jpg";